import { ICrudLocale } from '@app/i18n/interface';

export const USER_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  USER: {
    LABEL: {
      SINGULAR: 'Usuario',
      PLURAL: 'Usuarios',
    },
    FORM: {
      ADD_TITLE: 'Añadir usuario',
      EDIT_TITLE: 'Editar usuario',
      CARD_TITLE: 'Datos del usuario',
      BACK: 'Volver a Usuarios',
      ADD_DESCRIPTION:
        'Da de alta a alguien del equipo y elige su grupo; el grupo decide qué puede hacer.',
      EDIT_DESCRIPTION: 'Cambia los datos, el grupo o el acceso de esta persona.',
      FETCH_DEPENDENCIES_ERROR: 'No hemos podido cargar los grupos. Vuelve a intentarlo.',
    },
    FIELD: {
      NAME: 'Nombre',
      USERNAME: 'Usuario',
      EMAIL: 'Correo',
      GENDER: 'Género',
      ENABLED: 'Activo',
      LASTNAME: 'Apellido',
      PASSWORD: 'Contraseña',
      MOBILE: 'Teléfono',
      ROL: 'Rol',
      STATE: 'Estado',
      DNI: 'DNI',
      GROUPS: 'Grupos',
      BIRTHDATE: 'Fecha de nacimiento',
      SELF_GENERATED_PASSWORD: 'Contraseña autogenerada',
      LAST_LOGIN: 'Último acceso',
    },
    LIST: {
      DESCRIPTION:
        'Da de alta a tu equipo, cambia su grupo o desactiva el acceso de quien ya no lo necesite.',
      ADD: 'Añadir usuario',
      DELETED_HIDDEN: 'No se muestran los usuarios eliminados.',
      DELETED_SHOWN: 'Se muestran también los usuarios eliminados.',
      DELETED_SHOW: 'Mostrar los eliminados',
      DELETED_HIDE: 'Ocultar los eliminados',
      DELETED_BADGE: 'Eliminado',
      DELETED_ON: 'Eliminado el {{date}}',
      SEARCH_PLACEHOLDER: 'Buscar por nombre',
      TITLE: 'Equipo',
      CAPTION: 'Usuarios del back office',
      FILTERS: 'Filtros',
      EMPTY: 'No hay nadie del equipo que cumpla el filtro.',
      YOU: 'Tú',
      NEVER: 'Aún no ha entrado',
      ACTIVE: 'Activo',
      DISABLED: 'Desactivado',
      EDIT: 'Editar',
      EDIT_ARIA: 'Editar a {{name}}',
      DISABLE: 'Desactivar',
      DISABLE_ARIA: 'Desactivar a {{name}}',
      ENABLE: 'Reactivar',
      ENABLE_ARIA: 'Reactivar a {{name}}',
      DELETE: 'Eliminar',
      DELETE_ARIA: 'Eliminar a {{name}}',
      SELF_NOTE: 'Es tu cuenta, no se puede desactivar',
      LAST_ADMIN_NOTE: 'Es el último administrador, no se puede desactivar',
      TOGGLE_ERROR: 'No hemos podido cambiar el acceso. Vuelve a intentarlo.',
      HELP: 'Para eliminar a alguien, primero desactívalo. Desactivar cierra su acceso y se puede deshacer. Eliminar borra la cuenta y no se puede deshacer desde aquí. Tu cuenta y la del último administrador no se pueden desactivar ni eliminar.',
    },
    DELETE: {
      TITLE: '¿Eliminar a {{name}}?',
      BODY: 'Se borra su cuenta y no se puede deshacer desde aquí. Su nombre seguirá en el historial de las reservas que gestionó.',
      HINT: 'Si solo quieres que deje de entrar, déjalo desactivado.',
      CHECK: 'Para confirmar, escribe su correo: {{email}}',
      KEEP: 'Mantener el usuario',
      CONFIRM: 'Eliminar usuario',
      DONE: '{{name}} se ha eliminado.',
      ERROR: 'No hemos podido eliminar a {{name}}. Vuelve a intentarlo.',
    },
  },
};
